import { ArrowLeft, Clock } from "lucide-react";
import { useEffect, useState } from "react";

const PaymentValidationWaiting = ({ image, handle }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [dots, setDots] = useState("");
  const [timeElapsed, setTimeElapsed] = useState(0);

  // Simulation de l'heure actuelle
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
      setTimeElapsed((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Animation des points de chargement
  useEffect(() => {
    const dotTimer = setInterval(() => {
      setDots((prev) => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 500);
    return () => clearInterval(dotTimer);
  }, []);

  // Données de paiement simulées

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const getStatusMessage = () => {
    if (timeElapsed < 30) {
      return "Envoi de la demande de paiement...";
    } else if (timeElapsed < 60) {
      return "En attente de votre confirmation sur votre téléphone...";
    } else if (timeElapsed < 120) {
      return "Vérification du paiement en cours...";
    } else {
      return "Finalisation de la transaction...";
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={handle}
          className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Retour
        </button>
      </div>

      <div className="text-center">
        <div className="relative">
          <img
            className="mx-auto rounded-full bg-gray-100 h-24 w-24"
            src={image}
            alt=""
          />
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2 font-mtn my-2">
          Validation du paiement en cours{dots}
        </h1>
        <p className="text-gray-600 mb-4">{getStatusMessage()}</p>
        <div className="inline-flex items-center px-4 py-2 bg-yellow-100 text-yellow-800 rounded-full text-sm font-medium">
          <Clock className="w-4 h-4 mr-2" />
          Temps écoulé: {formatTime(timeElapsed)}
        </div>
      </div>
    </div>
  );
};

export default PaymentValidationWaiting;
